
export const NotesSection = ({ formikProps }) => {
    const { values, setFieldValue } = formikProps;

    const handleNoteChange = (value) => {
        try {
            setFieldValue('notes', value, true);
        } catch (err) {
            console.error('Error updating notes:', err);
        }
    };

    return (
        <div className="row">
            <div className="col-sm-12">
                <div className="card">
                    <div className="card-body">
                        <div className="notes-header">
                            <h3 className="section-title">Note</h3>
                        </div>

                        <div className="notes-item">
                            <textarea
                                rows={10}
                                cols={5}
                                className="form-control my-2"
                                placeholder="Enter Note"
                                value={values?.notes || ''}
                                onChange={e => handleNoteChange(e.target.value)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
